import React, { useEffect, useState } from 'react'
import '../styles/BrightnessScheduler.css'
import { Row, Col, Popover, message, Button } from 'antd'
import BrightnessSchedulerItem from './BrightnessSchedulerItem';
import { PlusCircleFilled } from '@ant-design/icons'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';

function BrightnessScheduler(props) {

    const [schedules, setSchedules] = useState([]);
    const { data, onSaved = () => { } } = props;
    const { Timelineschedules = [] } = data;

    var defaultData = {
        BrightnessScheduleID: -1,
        ScreenID: -1,
        WeekDay: "0,1,2,3,4,5,6",
        StartTime: "",
        EndTime: "",
        StartDate: "",
        EndDate: "",
        Brightness: 100,
        Priority: 1
    }

    const createTimelineSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;


        const params = new FormData();
        const { ScreenID } = data;
        const { WeekDay, StartTime, EndTime, StartDate, EndDate, Brightness, Priority } = scheduledata;

        // params.append("timelinescheduleid", TimelineScheduleID)
        params.append("screenid", ScreenID)
        params.append("weekday", WeekDay)
        params.append("starttime", StartTime)
        params.append("endtime", EndTime)
        params.append("startdate", StartDate)
        params.append("enddate", EndDate)
        params.append("brightness", Brightness)
        params.append("priority", Priority)


        requestServerPost("create_brightnessschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }
    const deleteTimelineSchedule = (scheduledata) => {
        const { requestServerPost, usertoken } = props;
        const params = new FormData();
        const { BrightnessScheduleID } = scheduledata;

        params.append("brightnessscheduleid", BrightnessScheduleID)

        requestServerPost("delete_brightnessschedule", params, { }, (response) => {
            reloadTimelineSchedules();
        }, usertoken);
    }

    const reloadTimelineSchedules = () => {
        const { requestServerGet, usertoken } = props;

        const { ScreenID } = data;

        requestServerGet("get_brightnessschedules", { screenid: ScreenID }, {}, (response) => {
            console.log("setSchedules " + JSON.stringify(response.data))

            // if (response.data && response.data.length === 0) {
            //     createTimelineSchedule(defaultData);
            // }
            setSchedules(response.data)
        }, usertoken);
    }

    useEffect(() => {
        // setSchedules(Timelineschedules)
        reloadTimelineSchedules();
    }, [props])


    useEffect(() => {
        // console.log(JSON.stringify(schedules))
    }, [schedules])

    return (
        schedules.length === 0 ? <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button onClick={() => {
                createTimelineSchedule(defaultData);
            }} type="primary">Create a New Schedule</Button>
        </div> : <div className="scheduler">
            <div className="itemgroup" style={{}}>
                <div>
                    {schedules.map((weekdaySchedule, index) => (
                        <BrightnessSchedulerItem key={`${weekdaySchedule.BrightnessScheduleID}_${index}`} data={weekdaySchedule} onSaved={onSaved} onRemove={(e) => {
                            if (schedules.length > 1) {
                                deleteTimelineSchedule(weekdaySchedule)
                            }
                            else {
                                // deleteTimelineSchedule(weekdaySchedule)
                                message.warn("You must have at least one schedule item")
                                e.preventDefault();
                            }

                        }
                        }></BrightnessSchedulerItem>
                    ))}
                </div>
                <div onClick={(e) => {
                    // console.log("add schedules " + schedules.length)
                    const sch = [...schedules]

                    createTimelineSchedule(defaultData)
                    e.preventDefault();
                }} className="btn-plus-item">
                    <PlusCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                </div>

            </div>
        </div>

    )
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(BrightnessScheduler);
